import axios from 'axios';

const API_URL = 'https://www.ouicsport.fr/api/search';

export const fetchOffers = () => {
    return axios.get(`${API_URL}/by-sport`); 
  };


  